import { useAppContext } from 'hooks/useAppContext';
import React, { useReducer } from 'react';


const gridState = {

}

const reducer = (state, action) => {
  switch (action.type) {
    case "GRID_FILTER_UPDATE":
      return {
        ...state,
        gridStates: {
          ...state.gridStates,
          [action.payload.selectedProject]: {
            ...state.gridStates[action.payload.selectedProject],
            [action.payload.gridTitle]: {
              ...state.gridStates[action.payload.selectedProject] && state.gridStates[action.payload.selectedProject][action.payload.gridTitle],
              filters: {
                ...state.gridStates[action.payload.selectedProject][action.payload.gridTitle] && state.gridStates[action.payload.selectedProject][action.payload.gridTitle].filters, // if there are existing filters, preserve them
                ...action.payload.filters // add new ones
              }
            }
          }
        }
      }
    case "GRID_FILTER_ACTIVE_UPDATE":
      return {
        ...state,
        gridStates: {
          ...state.gridStates,
          [action.payload.selectedProject]: {
            ...state.gridStates[action.payload.selectedProject],
            [action.payload.gridTitle]: {
              ...state.gridStates[action.payload.selectedProject] && state.gridStates[action.payload.selectedProject][action.payload.gridTitle],
              filterActive: action.payload.filterActive,
              ...(action.payload.filterActive === false) && { filters: {} }
            }
          }
        }
      }
    default: return state;
  }
};

let initialState = {
  gridStates: {}
};

const GridsContext = React.createContext(initialState);

const GridsProvider = ({ children }) => {

  let { selectedProject } = useAppContext();

  const [state, dispatch] = useReducer(reducer, initialState);

  const updateGridFilter = (updateObj) => {
    /* expecting payload of
      {
        "gridTitle": *title of grid*,
        "filters":{"InspectionNumber":{"filter":"az"}} // filter are column fieldName + {filter: *value*}
      }
    */
    dispatch({ type: "GRID_FILTER_UPDATE", payload: { ...updateObj, selectedProject: selectedProject ? selectedProject : "@global" } });
  };
  /**
   * 
   * expect payload of {
   *    gridTitle: *title of grid*
   *    filterActive: *boolean*
   * }
   * 
   */
  const updateGridFilterIsActive = (updateObj) => {
    dispatch({ type: "GRID_FILTER_ACTIVE_UPDATE", payload: { ...updateObj, selectedProject: selectedProject ? selectedProject : "@global" } });
  }

  return (
    <GridsContext.Provider
      value={{
        gridStates: state.gridStates,
        updateGridFilter,
        updateGridFilterIsActive
      }}
    >
      {children}
    </GridsContext.Provider>
  )
};

export { GridsContext, GridsProvider };
